<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 7/11/20
-->
<template>
    <div>BasePagerView</div>
</template>
<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import {DataFilter} from "@qwoach/firebase-data-manager";

export default {
	extends: BaseComponent,
    name: "BasePagerView",

	props: {
		defaultFilter: DataFilter,
	},

    data() {
        return {
            hasMore: true,
            dataPagerList: {},
			pagerTable: null
        }
    },
    // async mounted() {
    //     console.log("BasePagerView mounted")
    // },

    methods: {

		async getDataPager(pagerKey = "main"){
			console.log("BasePagerView.getDataPager: this.dataPagerList = ", this.dataPagerList, ", this.dataPagerList[pagerKey] = ", this.dataPagerList[pagerKey])
			if(!this.dataPagerList[pagerKey]){
				this.dataPagerList[pagerKey] = await this.dataPagerProvider(pagerKey)
			}
			return this.dataPagerList[pagerKey]
		},

        async loadData(pagerKey) {
			// console.log("BasePagerView.loadData ", this)
			try {
				this.progressDataLoading("Loading...")
				this.dataPagerList = []
				console.log("BasePagerView.loadData = ", this.dataPagerList, ", this.name = ", this)
				let pagerTable = this.getTableView(pagerKey)
				console.log("BasePagerView.loadData: pagerTable = ", pagerTable)
				await pagerTable.loadData()
			} catch (error) {
				this.handleError(error)
			}
			this.hideProgress()

			// try {
			// 	this.dataPagerList = []
            //     await this.onBeforeDataChanged()
            //     let dataPager = await this.getDataPager(pagerKey)
            //     let newData = await dataPager.next(this.pagerDataFilter.bind(this))
            //     console.log("loadData: newData = ", newData, ", dataPager.hasMore = ", dataPager.hasMore)
            //     await this.onDataChangedInternal(newData, pagerKey, true)
            //     this.hideProgress()
            //     this.$nextTick(_ => this.resetTableHasMoreItems(pagerKey, dataPager.hasMore))
            // } catch (error) {
            //     this.hideProgress()
            //     this.handleError(error)
            // }


		},

        async onDataChangedInternal(newData, pagerKey, isInitialLoad) {
			console.log("onDataChangedInternal", this)
			//mergePagerData must go before onDataChanged to make sure proper notification
			await this.mergePagerData(newData, pagerKey)
			await this.onDataChanged(newData, pagerKey, isInitialLoad)
        },

        resetTableHasMoreItems(pagerKey, hasMore) {
            let tableView = this.getTableView(pagerKey)
			console.log("resetTableHasMoreItems: hasMore = ", hasMore, ", tableView = ", tableView)
            if (tableView) {
                tableView.hasMore = hasMore
            }
        },


        async onBeforeDataChanged() {
            this.progressDataLoading("Loading...")
        },

        async onDataChanged(newData, pagerKey, isInitialLoad) {
			console.log("BasePagerView.onDataChanged", this)
			return await this.emitPromise('onDataLoaded', newData, pagerKey, isInitialLoad)
        },

        getTableView(pagerKey) {
            return this.pagerTable
        },
        getDataField(pagerKey) {
			return this.getTableView(pagerKey).dataArray
        },
        async dataPagerProvider(pagerKey) {
			console.log("BasePagerView.dataPagerProvider")
			if(this.findListenerByName('dataPagerProvider')){
				return this.emitPromise('dataPagerProvider', pagerKey)
			}
            throw "Not Implemented: dataPagerProvider"
        },



        async mergePagerData(newData, pagerKey) {
            let dataFull = this.getDataField(pagerKey)
			let dataPager = await this.getDataPager(pagerKey)
			console.log("mergePagerData: dataFull = ", dataFull, ", newData = ", newData)
			console.log("mergePagerData: this.dataPagerList = ", this.dataPagerList)
			console.log("mergePagerData: pagerKey = ", pagerKey, ", dataPager = ", dataPager)
            dataPager.mergeData(dataFull, newData)
        },


        async onLoadMore(table, pagerKey) {
            console.log("BasePagerView.onLoadMore", this)
			let hasMore = false
			let hasFilter = false
            try {
            	let dataPager = await this.getDataPager(pagerKey)
                let newData = await dataPager.next(this.pagerDataFilter.bind(this))
				hasMore = dataPager.hasMore
				//TODO finish logic to determine if the filters are the same
				// if(this.defaultFilter){
				// 	hasFilter = !dataPager.isFilterSame(this.defaultFilter)
				// } else {
					hasFilter = (dataPager.ref || {}).hasWhereClause
				// }
				console.log("BasePagerView.onLoadMore: hasFilter = ", hasFilter)
				// console.log("BasePagerView.onLoadMore: dataPager.hasFilterOptions() = ", dataPager.hasFilterOptions())
                await this.onDataChangedInternal(newData, pagerKey, false)
				return {hasMore, hasFilter}
            } catch (error) {
				this.hasMore = false
                this.handleError(error)
            }
			return {hasMore: false, hasFilter: false}

        },

		pagerDataFilter(ref){
			console.log("filterFunction: ref = ", ref)
			return ref
		},

		async notifyFilterChanged(){
			Object.keys(this.dataPagerList).forEach(pagerKey => {
				let dataPager = this.dataPagerList[pagerKey]
				dataPager.reset()
				this.loadData(pagerKey)
			})
		}
    }

}
</script>

<style>

</style>
